import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import { Prompt } from 'react-router-dom';
import ApplePaySettings from './containers/ApplePaySettings/ApplePaySettings';
import applePaySettingsStore from './store/applePaySettingsStore';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import Headers from '~/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import { getPromptProps } from '~/view/components/CustomPrompt/helper';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';

const ApplePay: FC = (): JSX.Element => {
  useEffect(() => {
    applePaySettingsStore.mount();

    return () => {
      applePaySettingsStore.unMount();
    };
  }, []);

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title={localeStore.t('apple_pay')} path={SCREENS.SETTINGS_INTEGRATIONS()} />
      </Headers>

      <ScrollableBlock showScrollbar className="mt-6">
        <ApplePaySettings settings={applePaySettingsStore.settings} />
      </ScrollableBlock>

      <LoadingOverlay visible={applePaySettingsStore.isLoading} />
      <Prompt when={applePaySettingsStore.isEdited} message={getPromptProps()} />
    </div>
  );
};

export default observer(ApplePay);
